import { useEffect, useState } from "react";
import useInfrastructure from "hooks/useInfrastructure.hook";
import LinesService from "services/lines.service";

export function useChatLinePhoto(lineId) {
  const { repositories } = useInfrastructure();
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!lineId) {
      setUrl(null);
      return;
    }

    let cancelled = false;
    let objectUrl = null;

    async function loadFile() {
      if (!lineId) return;

      try {
        let file = await repositories.files.getByEntity("CHAT", "LINE", lineId);
        let blob;

        if (file && file?.blob && !repositories.files.isExpired(file)) {
          blob = file.blob;
        } else {
          const {success, payload} = await LinesService.getLinePhoto(lineId);
          if (success && payload && (payload.body && payload.mimeType)) {
            blob = new Blob([payload.body], { type: payload.mimeType });
            
            const fileId = `chat:line:${lineId}:photo`;
            await repositories.files.upsert({
              id: fileId,
              scope: "CHAT",
              entity: "LINE",
              entityId: lineId,
              blob,
              mimeType: blob.type,
              cachedAt: new Date(),
              ttl: 24 * 60 * 60 * 1000 // 24 horas
            });
          }
        }

        if (cancelled) return;

        if (blob) {
          objectUrl = (window.URL || window.webkitURL).createObjectURL(blob);
          setUrl(objectUrl);
        }
      } catch (error) {
        console.error("useChatLinePhoto error:", lineId, error);
      }
    }

    loadFile();

    return () => {
      cancelled = true;
      if (objectUrl) {
        (window.URL || window.webkitURL).revokeObjectURL(objectUrl);
      }
    };
  }, [lineId, repositories]);

  return url;
}
